import React from 'react';
import { InputBase, Paper } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import SearchIcon from '@mui/icons-material/Search';
import CircleProgressIconButton from '../../../../buttons/CircleProgressIconButton';

const styles = theme => ({
    searchImagesWrapper: {
        padding: theme.spacing(0, 1),
        display: 'flex',
        alignItems: 'center',
        width: 300,
        background: theme.palette.background.paperDark
    },
    searchImagesInput: {
        marginLeft: theme.spacing(1),
        flex: 1
    },
    searchImagesIcon: {
        padding: 10
    }
});

const MediaItemsSearch = (props) => {
    const { classes, value, onValueChange, onValueSubmit,  isSearching, placeholder } = props;
    
    const onSearchKeyUp = (event) => {
        if(event.key === 'Enter' || event.keyCode === 13) {
            onValueSubmit();
        }
    };

    const onSearchButtonClick = () => {
        onValueSubmit();
    };
    
    return (
        <Paper className={classes.searchImagesWrapper}>
            <InputBase
                className={classes.searchImagesInput}
                placeholder= {placeholder}
                inputProps={{ 'aria-label': placeholder}}
                value={value}
                onChange={onValueChange}
                onKeyUp={onSearchKeyUp}
            />
            <CircleProgressIconButton
                className={classes.searchImagesIcon} 
                loading={isSearching}
                onClick={onSearchButtonClick}
                aria-label='Search'
            >
                <SearchIcon />
            </CircleProgressIconButton>
        </Paper>
    );
};

export default withStyles(MediaItemsSearch, styles);